<template>
    <div class="inputIt">
        <div class='inputI' :style="{'margin-top': top+'px!important'}">
            <div>{{title}}</div>
            <div>
                <div><span>*</span> 姓名</div>
                <el-input class='inputt' placeholder='请输入姓名'  v-model='name'></el-input>
            </div>
            <div>
                <div><span>*</span> 手机号</div>
                <el-input class='inputt' placeholder='请输入手机号'  v-model='tel'></el-input>
<!--                <el-input class='inputt' placeholder='短信验证码'  v-model='code'></el-input>-->
<!--                <div class='code'>获取验证码</div>-->
            </div>
            <div>
<!--                <el-checkbox v-model="checked">我已阅读并同意 <span>《隐私政策》</span></el-checkbox>-->
            </div>
            <div @click="getFreeTrial">确认提交</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'post' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
export default {
    props:{
        title: {
            type: String,
            default: '获取数智化解决方案'
        },
        top: {
            type: String,
            default: '200'
        },
    },
    name: 'inputIt',
    data() {
        return {
            tel: '',
            code: '',
            name: '',
        }
    },
    mounted() {

    },
    methods:{
        getFreeTrial() {
            let url = "https://iboran.com/api.php/cms/addform"
            let params = {
                fcode: 2,
                tel: this.tel
            }
            uploadAction(url, params).then(res => {
                // console.log(res, 'rrrrrrrrrrrrrr-----------ssssssss')
                alert(res.data.data)
            }).catch(err => {
                alert(err.message)
            })

            var _this = this;
            // axios({
            //     method: 'post',
            //     url: `http://cs.djbhwang.com/api.php/cms/addform?fcode=${2}&tel=${this.tel}`,
            //     // contentType: "multipart/form-data",
            //     contentType: "application/json",
            //     // headers: {
            //     //     'Content-Type': 'multipart/form-data',
            //     //     'Access-Control-Allow-Origin': ('Access-Control-Allow-Origin', '*')
            //     // },
            // }).then(function (response) {
            //     console.log(response, 'responseresponse------------responseresponse');
            //     // 拿到data
            //     _this.result = response.data;
            //     console.log(_this.result);
            // }).catch(function (response) {
            //     console.log(response, 'reason------------reason')
            // })
        }
    }
   }
</script>

<style lang="scss" scoped>
    .inputI{
        /deep/ .el-input__inner{
            height: 30px!important;
        }
        /deep/ .el-checkbox__label{
            color: #333333 !important;
        }
        // margin-top: 200px!important;
        transform: translatey(-30%);
        padding: 30px 30px;
        width: 360px;
        background: url(../assets/form-bg.png) #fff no-repeat top right;
        box-shadow: 0px 4px 8px 0px rgba(175, 175, 175, 0.1);
        border-radius: 6px;
        font-size: 14px;
        >div:nth-of-type(1) {
            line-height: 24px;
            font-size: 22px;
            color: #e61318;
            font-weight: 700;
            text-align: center;
            padding-bottom: 30px;
        }
        >div:nth-of-type(2) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            >div{
                >span{
                    color: #e60012 !important;
                }
                font-size: 14px;
                color: #333333;
                line-height: 20px;
            }
            .inputt{
                width: 262px;
                height: 30px;
                margin-right: 26px;
            }
        }
        >div:nth-of-type(3) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            >div{
                >span{
                    color: #e60012 !important;
                }
                font-size: 14px;
                color: #333333;
                line-height: 20px;
            }
            .inputt{
                width: 262px;
                height: 30px;
                margin-right: 26px;
            }

            // 获取验证码用下面这个style
            //display: flex;
            //align-items: center;
            //justify-content: flex-end;
            //margin-top: 10px;
            //>.code{
            //    width: 106px;
            //    height: 30px;
            //    background: #e14c46;
            //    float: right;
            //    color: #fff;
            //    line-height: 50px;
            //    justify-content: center;
            //    align-items: center;
            //    display: flex;
            //    border-radius: 0 4px 4px 0;
            //    cursor: pointer;
            //    margin-right: 26px;
            //}
            //>.inputt{
            //    width: 158px;
            //    height: 30px;
            //}
        }
        >div:nth-of-type(4) {
            margin-top: 26px;
            span{
                color: #e60012 !important;
            }
        }
        >div:nth-of-type(5) {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            font-size: 16px;
            color: #ffffff;
            font-weight: 500;
            text-align: center;
            border: none;
            margin-top: 10px;
            background: #cc0817;
            cursor: pointer;
        }
    }
</style>

<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }
}
@media all and (max-width: 980px) {
    .inputI{
        display: none !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/inputT.vue